module.exports = __webpack_public_path__ + "img/image.522498bc.jpg";